import React from 'react';
import format_img from '../../Assests/assets/images/icons-8-video-file.svg';
import time_img from '../../Assests/assets/images/icons-8-timesheet.svg';
import person_img from '../../Assests/assets/images/icons-8-person.svg';

const CourseTitleInfo = (props) => {
  return (
    <div class='main-title-left-container'>
      {/*      <link href="//db.onlinewebfonts.com/c/02fb003368979ba04752e4f3b4c4cebd?family=Graphik+Web+Semibold" rel="stylesheet" type="text/css"/>*/}
      <div class='course-info-container'>
        <span className='course-info-title'>
          Reading and Analysing Financial Statements
        </span>
        <span id="course-info-title-subtitle-gutter"></span>
        <span className='course-info-subtitle'>
          In this <b>online video course</b> you will learn to interpret 
          financial statements and draw meaningful analysis.
        </span>
        <span id="course-info-subtitle-properties-gutter"></span>
        <div id='course-info-properties'>
          <span class='course-info-properties-item'>
            <img class='format-img' src={format_img}/>
            Format: Pre-recorded videos
          </span>
          <span class='course-info-properties-item'>
            <img class='format-img' src={time_img}/>
            Access: Lifetime
          </span>
          <span class='course-info-properties-item'>
            <img class='format-img' src={person_img}/>
            Eligibility Criteria: Anyone & Everyone
          </span>
        </div>
        <span id="course-info-properties-buy-gutter"></span>
        <span class="course-title-buy-button-container">
          <button class="course-title-buy-button">
            <span class='course-title-buy-button-text'>
              {props.isLoggedIn && 'Buy Now'}
              {!props.isLoggedIn && 'Login'}
            </span>
          </button>
          <span id="course-info-buy-amt-gutter"></span>
          <span id="course-info-amt">
            <strike>₹ 299</strike>   ₹ 199
          </span>
        </span>
      </div>
    </div>
  )
}
export default CourseTitleInfo;
